import analytics from '../../../analytics'

export const amazonProviderId = 'www.amazon.com'

const authDefault = {
  status: '',
  access_token: '',
  token_type: '',
  scope: '',
  expires_in: ''
}

const profileDefault = {
  CustomerId: '',
  Name: '',
  PrimaryEmail: ''
}

export const amazonModule = {
  state: {
    authResponse: authDefault,
    profile: profileDefault,
    loading: false
  },
  getters: {
    amazonLoginEntry: state => {
      return { [amazonProviderId]: state.authResponse.access_token }
    },
    amazonEmailAddress: state => {
      return state.profile.PrimaryEmail
    },
    amazonName: state => {
      return state.profile.Name
    },
    amazonSigninLoading: state => {
      return state.loading
    }
  },
  mutations: {
    setAmazonSigninLoading (state, amazonSigninLoading) {
      state.loading = amazonSigninLoading
    },
    /**
     * Update authentication response values
     */
    updateAmazonAuthResponse (state, response) {
      state.authResponse.access_token = response.access_token
      state.authResponse.token_type = response.token_type
      state.authResponse.status = response.status
      state.authResponse.scope = response.scope
      state.authResponse.expires_in = response.expires_in

      console.log('Amazon Sign-In Success: %O', response)
    },

    /**
     * Update the Amazon profile details on profile retrieval
     */
    updateAmazonProfile (state, response) {
      state.profile.PrimaryEmail = response.profile.PrimaryEmail
      state.profile.CustomerId = response.profile.CustomerId
      state.profile.Name = response.profile.Name

      console.log('Retrieved Amazon profile: %O', response)
    },

    /**
     * Failed Amazon Signin
     */
    onAmazonSignInError (state, response) {
      state.loading = false
      console.log('Amazon Sign-In authorization failed: ' + response.error_description)
    },

    /**
     * Amazon SignOut
     */
    onAmazonSignOut (state, response) {
      state.authResponse = authDefault
      state.profile = profileDefault

      console.log('Amazon Sign-Out Success')
    }
  },
  actions: {
    /**
     * Successful Amazon Sign-In
     */
    onAmazonSignInSuccess (context, response) {
      context.commit('updateAmazonAuthResponse', response)

      var start = analytics.currentTime()
      window.amazon.Login.retrieveProfile(context.state.authResponse.access_token, (response) => {
        var end = analytics.currentTime()
        analytics.time('API', 'signin-amazon', end - start, 'success')
        context.commit('updateAmazonProfile', response)
      })
    },
    onLogin (context) {
      context.commit('setAmazonSigninLoading', false)
    }
  }
}

export default amazonModule



// WEBPACK FOOTER //
// ./src/store/auth/idp/amazon.js